import React from 'react';
import { ReusableModal } from '../modals/ReusableModal';
import { PriceComponent } from '@/types';
import { useCreateUpdatePriceComponentMutation } from '../services/edgeApi';
import toast from 'react-hot-toast';
import { PriceComponentForm } from './PriceComponentForm';

export type EditPriceComponentModalProps = {
  component: PriceComponent | null;
  onClose: () => void;
  afterSave?: () => void;
};

export const EditPriceComponentModal: React.FC<
  EditPriceComponentModalProps
> = ({ component, onClose, afterSave }) => {
  const [updateComponentTrigger] = useCreateUpdatePriceComponentMutation();

  const onSave = async (updatedComponent: Partial<PriceComponent>) => {
    const result = await updateComponentTrigger(updatedComponent);
    if ('error' in result) {
      toast.error('Failed to save component');
    } else {
      toast.success(
        `Component #${updatedComponent.id} ${
          component ? 'updated' : 'created'
        } successfully`,
      );
      onClose();
      afterSave?.();
    }
  };

  return (
    <ReusableModal size="lg" isOpen={Boolean(component)} onClose={onClose}>
      <h4 className="text-center">
        {component
          ? `Edit Price Component #${component.id}`
          : 'Add New Component'}
      </h4>
      <PriceComponentForm
        priceComponent={component}
        onSave={onSave}
        onCancel={onClose}
      />
    </ReusableModal>
  );
};
